import React from 'react';
import { SectionWrapper } from '../ui/SectionWrapper';
import { CTAButton } from '../ui/CTAButton';
import { BookOpenIcon, HeadphonesIcon, GiftIcon, AudioLinesIcon, LayersIcon, CheckIcon } from 'lucide-react';
import { AudioPlayer } from '../ui/AudioPlayer';
export function ProductSection() {
  return <SectionWrapper id="producto" withGlow glowPosition="top" data-id="element-297">
      <div className="max-w-4xl mx-auto" data-id="element-298">
        <div className="text-center mb-16" data-id="element-299">
          <p className="text-[#c9a84c] text-sm font-semibold tracking-[0.2em] uppercase mb-6" data-id="element-300">
            Lo que recibes hoy
          </p>
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold text-[#e8e6e1] mb-6 leading-tight" data-id="element-301">
            Este no es un libro.{' '}
            <span className="text-gold-gradient" data-id="element-302">Es un protocolo completo</span>{' '}
            de reprogramación de identidad.
          </h2>
        </div>

        {/* Product items */}
        <div className="space-y-6 mb-16" data-id="element-303">
          <div className="flex items-start gap-5 p-6 rounded-xl bg-[#0d1321]/60 border border-[#252b45]/50" data-id="element-304">
            <div className="w-12 h-12 rounded-lg bg-[#c9a84c]/10 flex items-center justify-center flex-shrink-0" data-id="element-305">
              <BookOpenIcon className="w-6 h-6 text-[#c9a84c]" aria-hidden="true" data-id="element-306" />
            </div>
            <div data-id="element-307">
              <h3 className="text-[#e8e6e1] font-semibold text-lg mb-1" data-id="element-308">
                Ebook Completo
              </h3>
              <p className="text-[#9a9aab] text-sm leading-relaxed" data-id="element-309">
                El protocolo paso a paso para reprogramar tu identidad
                subconsciente en 21 días.
              </p>
              <span className="text-[#c9a84c] text-sm font-medium" data-id="element-310">
                Valor: $97 USD
              </span>
            </div>
          </div>

          <div className="flex items-start gap-5 p-6 rounded-xl bg-[#0d1321]/60 border border-[#252b45]/50" data-id="element-311">
            <div className="w-12 h-12 rounded-lg bg-[#c9a84c]/10 flex items-center justify-center flex-shrink-0" data-id="element-312">
              <HeadphonesIcon className="w-6 h-6 text-[#c9a84c]" aria-hidden="true" data-id="element-313" />
            </div>
            <div data-id="element-314">
              <h3 className="text-[#e8e6e1] font-semibold text-lg mb-1" data-id="element-315">
                Audiobook Completo — +50 minutos
              </h3>
              <p className="text-[#9a9aab] text-sm leading-relaxed" data-id="element-316">
                Escucha el protocolo completo narrado profesionalmente. Ideal
                para absorber mientras caminas, manejas o descansas.
              </p>
              <span className="text-[#c9a84c] text-sm font-medium" data-id="element-317">
                Valor: $47 USD
              </span>
            </div>
          </div>

          <div className="flex items-start gap-5 p-6 rounded-xl bg-[#0d1321]/60 border border-[#252b45]/50" data-id="element-318">
            <div className="w-12 h-12 rounded-lg bg-[#c9a84c]/10 flex items-center justify-center flex-shrink-0" data-id="element-319">
              <GiftIcon className="w-6 h-6 text-[#c9a84c]" aria-hidden="true" data-id="element-320" />
            </div>
            <div data-id="element-321">
              <h3 className="text-[#e8e6e1] font-semibold text-lg mb-1" data-id="element-322">
                10 Bonos Prácticos de Implementación
              </h3>
              <p className="text-[#9a9aab] text-sm leading-relaxed" data-id="element-323">
                Ejercicios, plantillas y guías diseñadas para que apliques cada
                fase del protocolo de inmediato.
              </p>
              <span className="text-[#c9a84c] text-sm font-medium" data-id="element-324">
                Valor: $67 USD
              </span>
            </div>
          </div>

          <div className="flex items-start gap-5 p-6 rounded-xl bg-[#0d1321]/60 border border-[#252b45]/50" data-id="element-325">
            <div className="w-12 h-12 rounded-lg bg-[#c9a84c]/10 flex items-center justify-center flex-shrink-0" data-id="element-326">
              <AudioLinesIcon className="w-6 h-6 text-[#c9a84c]" aria-hidden="true" data-id="element-327" />
            </div>
            <div data-id="element-328">
              <h3 className="text-[#e8e6e1] font-semibold text-lg mb-1" data-id="element-329">
                7 Audios de Reprogramación Subconsciente
              </h3>
              <p className="text-[#9a9aab] text-sm leading-relaxed" data-id="element-330">
                Audios con frecuencias específicas diseñados para reprogramar
                patrones mientras duermes o meditas.
              </p>
              <span className="text-[#c9a84c] text-sm font-medium" data-id="element-331">
                Valor: $57 USD
              </span>
            </div>
          </div>

          {/* Sistema Completo de Integración card */}
          <div className="flex items-start gap-5 p-6 rounded-xl bg-[#0d1321]/60 border border-[#252b45]/50" data-id="element-332">
            <div className="w-12 h-12 rounded-lg bg-[#c9a84c]/10 flex items-center justify-center flex-shrink-0" data-id="element-333">
              <LayersIcon className="w-6 h-6 text-[#c9a84c]" aria-hidden="true" data-id="element-334" />
            </div>
            <div data-id="element-335">
              <h3 className="text-[#e8e6e1] font-semibold text-lg mb-1" data-id="element-336">
                Sistema Completo de Integración
              </h3>
              <p className="text-[#9a9aab] text-sm leading-relaxed" data-id="element-337">
                El framework para integrar todos los elementos en tu rutina
                diaria y hacer el cambio permanente.
              </p>
              <span className="text-[#c9a84c] text-sm font-medium" data-id="element-338">
                Valor: $29 USD
              </span>
            </div>
          </div>
        </div>

        {/* Audio Player Section */}
        <div className="mb-16" data-id="element-339">
          <div className="text-center mb-3" data-id="element-340">
            <p className="text-[#c9a84c] text-xs font-semibold tracking-[0.25em] uppercase mb-4" data-id="element-341">
              Bono exclusivo
            </p>
          </div>
          <AudioPlayer src="https://drive.google.com/file/d/1OpzjmM_lPNi5jdyf96ZSFXExG7s3AU08/preview" title="Este audio inicia la reprogramación de tu mente" subtitle="La mayoría no está preparada para este nivel de transformación. Escúchalo ahora." durationLabel="+50 minutos" data-id="element-342" />
          <p className="text-center text-[#6b6b7b] text-xs mt-4 italic" data-id="element-343">
            Este es solo uno de los 7 audios de reprogramación incluidos en el
            protocolo completo. Duración del audiobook completo: +50 minutos.
          </p>
        </div>

        {/* Value stacking */}
        <div className="text-center bg-gradient-to-b from-[#0d1321] to-[#0a0e1a] border border-[#252b45] rounded-2xl p-8 md:p-12" data-id="element-344">
          <div className="flex items-center justify-center gap-3 mb-4" data-id="element-345">
            <CheckIcon className="w-5 h-5 text-[#c9a84c]" aria-hidden="true" data-id="element-346" />
            <span className="text-[#9a9aab] text-lg" data-id="element-347">
              Todo incluido en un solo acceso
            </span>
          </div>

          <div className="mb-2" data-id="element-348">
            <span className="text-[#6b6b7b] text-lg line-through" data-id="element-349">
              Valor total: $297 USD
            </span>
          </div>

          <div className="mb-8" data-id="element-350">
            <span className="text-[#e8e6e1] text-lg" data-id="element-351">
              Hoy disponible por solo{' '}
            </span>
            <span className="font-display text-5xl md:text-6xl font-bold text-gold-gradient" data-id="element-352">
              $27
            </span>
            <span className="text-[#e8e6e1] text-lg" data-id="element-353"> USD</span>
          </div>

          <CTAButton size="large" data-id="element-354">
            Acceder al protocolo completo ahora
          </CTAButton>

          <p className="text-[#6b6b7b] text-sm mt-4" data-id="element-355">
            Pago único · Acceso de por vida · Sin suscripciones
          </p>
        </div>
      </div>
    </SectionWrapper>;
}